<template>
  <svg class="fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
    <path
      d="m101.153 94.393 17.412 3.071C107.305 115.784 87.079 128 64 128c-23.071 0-43.292-12.208-54.553-30.517l17.415-3.07C35.665 105.148 49.032 112 64 112c14.976 0 28.35-6.859 37.153-17.607ZM64 0c23.08 0 43.306 12.217 54.565 30.537l-17.412 3.07C92.351 22.859 78.976 16 64 16c-14.968 0-28.335 6.85-37.138 17.588L9.447 30.517C20.708 12.208 40.929 0 64 0Z"
      fill-rule="nonzero"
    />
  </svg>
</template>
